import { z } from 'zod'

/**
 * Auth response shapes. Copied field-for-field from the reference repo's
 * backend contract (inventory-app-mariadb `TokenResponse` / `UserResponse`) so
 * this frontend and the KH backend agree on the wire format exactly.
 */
export const userResponseSchema = z.object({
  user_id: z.number(),
  username: z.string(),
  display_name: z.string().nullish(),
  role: z.string(),
  must_reset: z.boolean().default(false),
})
export type UserResponse = z.infer<typeof userResponseSchema>

export const tokenResponseSchema = z.object({
  access_token: z.string(),
  token_type: z.string().default('bearer'),
  user: userResponseSchema,
})
export type TokenResponse = z.infer<typeof tokenResponseSchema>
